import { FC } from 'react';
import { useSearchParams } from 'next/navigation';
import { getUtmParams } from '@shared/helpers/getUtmParams.helper';
import { analytics } from '@shared/utils/segment.utils';
import { Container } from './LoginButton.style';
const LoginButtonLogic: FC = () => {
  const searchParams = useSearchParams();
  const defaultUtmParams = {
    campaign: 'CPBrandsite',
    source: 'Website_Direct',
    medium: 'TopRightLogin'
  };
  const cdpLoginUrl = `${process.env.CDP_DOMAIN}/sso?callbackUrl=${encodeURIComponent(window.location.href)}&${getUtmParams(searchParams, defaultUtmParams)}`;
  return <Container type="default" onClick={() => {
    analytics.track('Login Click', {
      event: 'Login Click'
    });
    analytics.track('Offsite Linked', {
      event: 'Offsite Linked',
      detination_url: `${cdpLoginUrl}`
    });
    window.location.href = `${cdpLoginUrl}`;
  }}>
            เข้าสู่ระบบ
        </Container>;
};
export default LoginButtonLogic;